<template>

  <div class="bill-product-table">

    <div :style="textInfo">

      <div class="d-flex align-items-center">

        <p class="text-dark font-size-h5 font-weight-bold mb-0">Danh sách sản phẩm</p>
         <span
          class="badge badge-primary badge-pill ml-2"
          v-if="totalBillItemsQuantity"
          > Tổng SL: {{ totalBillItemsQuantity }} </span
        >
      </div>

    </div>
     <b-row class="mb-5 align-items-center"
      > <b-col
        cols="2"
        class="pr-0"
        > <b-form-select
          class="select-style"
          v-model="productSearch.searchType"
          :options="optionProductSearchType"
          size="sm"
          value-field="id"
          text-field="name"
          :disabled="isDisabled"
        ></b-form-select
        > </b-col
      > <b-col
        :cols="showBulkImeiImportButton ? 7 : 10"
        class="pl-0"
        > <treeselect
          :load-options="loadOptionProducts"
          :multiple="false"
          :async="true"
          :placeholder="productSearch.placeHolder"
          :cache-options="false"
          retryText="Thử lại..."
          retryTitle="Nhấp thử lại"
          searchPromptText="Nhập để tìm kiếm..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          openDirection="bottom"
          @select="onSelectProduct"
          :always-open="isOpenProductSearch"
          @search-change="onSearchChange"
          :disabled="isDisabled"
          > <label
            slot="option-label"
            slot-scope="{ node, labelClassName }"
            :class="labelClassName"
            > <template
              >
              <div>
                 <b
                  class="text-primary"
                  v-show="productSearch.searchType !== SEARCH_TYPE.FLEXIBLE_COMBO"
                  >( {{ convertPrice(node.raw.sellingPriceMask) }} )</b
                > <b
                  :class="node.raw.inStockQuantity > 0 ? 'text-success' : 'text-danger'"
                  v-show="productSearch.searchType !== SEARCH_TYPE.FLEXIBLE_COMBO"
                  > ( TCB:{{ node.raw.inStockQuantity }} ) </b
                > {{ node.raw.label }} <span
                  v-if="node.raw.imeiCode && node.raw.imeiCode.trim().length > 0"
                  class="text-warning"
                  > - IMEI: {{ node.raw.imeiCode }} </span
                >
              </div>
               </template
            > </label
          > </treeselect
        > </b-col
      > <b-col
        v-if="showBulkImeiImportButton"
        cols="3"
        class="pl-2 d-flex align-items-center"
        > <b-button
          variant="outline-secondary"
          size="sm"
          class="bill-product-bulk-imei-btn w-100 font-weight-bolder"
          :disabled="isDisabled"
          @click="showBulkImportImeiModal"
          > <i class="far fa-file-excel bill-product-bulk-imei-btn__icon"></i> Nhập IMEI excel
          </b-button
        > </b-col
      > </b-row
    >
    <table class="table table-bordered table-hover">

      <thead>

        <tr>

          <th class="header-color text-center">STT</th>

          <th class="header-color text-center">Sản phẩm</th>

          <th
            v-if="groupedImeiByProduct"
            class="header-color text-center"
          >
             IMEI
          </th>

          <th class="header-color text-center">Số lượng</th>

          <th class="header-color text-center">Giá</th>

          <th class="header-color text-center">Chiết khấu</th>

          <th class="header-color text-center">Thành tiền</th>

          <th></th>

        </tr>

      </thead>

      <tbody
        v-for="(productItem, index) in billModel.billItems"
        :key="index"
      >

        <td
          class="text-center"
          style="width: 4%"
        >
           <span
            class="font-weight-bolder"
            v-if="isItemMainDisplay(productItem.itemType)"
            >{{ productItem.stt }}</span
          > <span v-else
            > <i
              v-if="isItemAttachDisplay(productItem.itemType)"
              class="fas fa-tags"
            ></i
            > <i
              v-else
              class="fas fa-gift"
            ></i
            > </span
          >
        </td>

        <td
          style="width: 30%; padding-top: 20px; padding-bottom: 20px"
          :style="getAttachIndentStyle(productItem)"
        >

          <div style="display: flex; gap: 8px; align-items: center">
             <ProductImage :src="productItem.imageUrl || productItem.productImageUrl" />
            <div>

              <p
                class="m-0"
                style="font-style: italic"
              >
                 ({{ productItem.barCode }})
              </p>

              <p
                class="m-0"
                style="font-weight: 500"
              >
                 {{ productItem.productCode }}
              </p>

              <p class="m-0 font-weight-bolder"> {{ productItem.productName }} </p>
               <b-input-group
                v-if="
                  productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI && !groupedImeiByProduct
                "
                class="btn-imei"
                > <b-form-input
                  size="sm"
                  v-model="productItem.imeiCode"
                  placeholder="Nhập mã IMEI"
                  :disabled="true"
                  autocomplete="off"
                ></b-form-input
                > <template #append
                  > <b-button
                    size="sm"
                    variant="secondary"
                    title="Danh sách IMEI"
                    class="font-weight-bolder"
                    v-b-tooltip.right
                    @click="addProductImei(productItem)"
                    > <i class="fas fa-list-ul text-dark"></i> </b-button
                  > </template
                > <b-form-invalid-feedback :state="$v.itemChoice.imeiCode.minLength"
                  >Vui lòng nhập IMEI code > 3 kí tự</b-form-invalid-feedback
                > </b-input-group
              >
              <div
                class="table-responsive"
                v-show="productItem.comboItems !== undefined && productItem.comboItems.length > 0"
              >

                <table>

                  <tr
                    v-for="(items, i) in productItem.comboItems"
                    :key="i"
                    style="border-top: 1px solid gray"
                  >

                    <td style="border: none">
                       <i
                        style="color: rgb(24, 28, 50)"
                        class="fas fa-cube"
                      ></i
                      >
                    </td>

                    <td style="border: none; width: -webkit-fill-available">
                       {{ items.productName }} <i style="font-size: unset; color: unset"
                        >({{ convertPrice(items.sellingPrice) }})</i
                      >
                    </td>

                    <td style="border: none">{{ items.quantity }}</td>

                  </tr>

                </table>

              </div>

              <div
                v-if="
                  isItemMainDisplay(productItem.itemType) ||
                  isItemAttachDisplay(productItem.itemType)
                "
              >

                <div v-show="productItem.note">
                   <b-button
                    size="sm"
                    disabled
                    style="color: black; cursor: auto"
                    class="mr-1 font-italic btn-hidden"
                    :id="`popover-note-${index}`"
                    > Ghi chú: </b-button
                  > <span class="text-note"> {{ productItem.note }}</span
                  >
                </div>

              </div>

            </div>

          </div>

        </td>

        <td
          v-if="groupedImeiByProduct"
          class="px-2 align-middle"
          style="width: 11%"
        >

          <div
            v-if="
              productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI &&
              isItemMainDisplay(productItem.itemType)
            "
          >
             <ImeiInputModal
              :productItem="productItem"
              :storeId="billModel.storeId"
              :in-stock="true"
              stock-only
              enable-view-edit-mode
              :readonly="isDisabled"
            />
          </div>

        </td>

        <td
          class="td-middle text-right"
          style="width: 10%"
        >

          <div
            v-if="
              [PRODUCT_TYPE.PRODUCT, PRODUCT_TYPE.PRODUCT_COMBO].includes(
                productItem.productType,
              ) ||
              (groupedImeiByProduct && productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI)
            "
          >
             <BInputNumber
              v-model="productItem.quantity"
              style="border-color: #007bff"
              placeholder="Số lượng"
              :inputClass="'w-100 text-right'"
              :disabled="
                !isItemMainDisplay(productItem.itemType) ||
                isDisabled ||
                (groupedImeiByProduct && productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI)
              "
            />
          </div>

          <div v-else> {{ productItem.quantity }} </div>

        </td>

        <td
          class="td-middle text-right"
          style="width: 15%; position: relative; padding-top: 2px; padding-bottom: 2px"
        >

          <div v-if="isItemMainDisplay(productItem.itemType)">
             <BInputNumber
              v-model="productItem.sellingPriceMask"
              style="border-color: #007bff"
              placeholder="Đơn giá"
              :inputClass="'w-100 text-right'"
              :disabled="!isCanEditPrice"
            />
          </div>

          <div v-else> {{ convertPrice(productItem.sellingPrice) }} </div>
           <span
            v-if="productItem.discountAmount || calculateApplyBillDiscountAmount(productItem)"
            class="text-muted small"
            style="position: absolute; right: 10px; white-space: nowrap; font-weight: 600"
            > Giá sau giảm:<br /> {{ convertPrice(calculateAfterDiscountAmount(productItem)) }}
            </span
          >
        </td>

        <td
          class="td-middle text-right bill-product-discount-cell"
          style="width: 20%; position: relative"
        >

          <div
            v-if="
              isItemMainDisplay(productItem.itemType) &&
              !productItem.flexibleComboId &&
              !productItem.voucherCode
            "
          >

            <div class="bill-product-discount-inner">
               <b-input-group class="bill-product-discount-input-group"
                > <template #prepend
                  > <b-dropdown
                    :text="
                      productItem.discountType == DISCOUNT_AMOUNT_TYPE.MONEY
                        ? '$'
                        : productItem.discountType == DISCOUNT_AMOUNT_TYPE.PERCENT
                          ? '%'
                          : ''
                    "
                    size="sm"
                    variant="outline-primary"
                    :disabled="!isCanEditDiscount"
                    > <b-dropdown-item
                      @click="onChangeDiscountType(productItem, DISCOUNT_AMOUNT_TYPE.MONEY)"
                      >{{ '$' }}</b-dropdown-item
                    > <b-dropdown-item
                      @click="onChangeDiscountType(productItem, DISCOUNT_AMOUNT_TYPE.PERCENT)"
                      >{{ '%' }}</b-dropdown-item
                    > </b-dropdown
                  > </template
                > <BInputNumber
                  v-model="productItem.discountAmount"
                  style="border-color: #007bff"
                  placeholder="Chiết khấu"
                  :inputClass="'text-right'"
                  :disabled="!isCanEditDiscount"
                /> </b-input-group
              > <span
                v-if="rowHasPromotionLabel(productItem)"
                v-b-tooltip.hover
                :title="getPromotionTooltipText(productItem)"
                class="bill-product-ctkm-badge"
                > <i class="fas fa-tag"></i> <span class="bill-product-ctkm-badge__text">{{
                  getPromotionBadgeText(productItem)
                }}</span
                > </span
              > <span
                v-if="extraProgramCount(productItem) > 0"
                v-b-tooltip.hover
                :title="extraProgramTooltip(productItem)"
                class="bill-product-extra-badge mt-1"
                > <i class="fas fa-layer-group"></i> +{{ extraProgramCount(productItem) }} giảm giá
                </span
              >
              <div
                v-if="isShowMaxValueDescription(productItem)"
                class="text-muted small"
                style="margin-top: 2px"
              >
                 Chiết khấu vượt {{ productItem.originalPercentDiscountAmount }}%
              </div>
               <b-form-invalid-feedback :state="validateDiscountArr[productItem.id]"
                > {{ messageErrorDiscount }} </b-form-invalid-feedback
              >
            </div>

          </div>

          <div
            v-else-if="
              isItemMainDisplay(productItem.itemType) &&
              !productItem.flexibleComboId &&
              lineHasStackedDiscount(productItem)
            "
            class="bill-product-discount-stack-wrap"
          >
             <span class="d-block font-weight-bold">{{
              convertPrice(stackedLineDiscountTotal(productItem))
            }}</span
            > <span class="text-muted small d-block"
              >CTGG: {{ convertPrice(Number(productItem.discountProgramAmount) || 0) }}</span
            > <span class="text-muted small d-block"
              >Voucher: {{ convertPrice(Number(productItem.voucherAmount) || 0) }}</span
            > <span
              v-if="rowHasPromotionLabel(productItem)"
              v-b-tooltip.hover
              :title="getPromotionTooltipText(productItem)"
              class="bill-product-ctkm-badge mt-1"
              > <i class="fas fa-tag"></i> <span class="bill-product-ctkm-badge__text">{{
                getPromotionBadgeText(productItem)
              }}</span
              > </span
            > <span
              v-if="extraProgramCount(productItem) > 0"
              v-b-tooltip.hover
              :title="extraProgramTooltip(productItem)"
              class="bill-product-extra-badge mt-1"
              > <i class="fas fa-layer-group"></i> +{{ extraProgramCount(productItem) }} giảm giá
              </span
            >
            <div class="d-flex justify-content-end mt-1 flex-wrap">
              <template v-if="enableMultiVoucherRetail && lineVoucherEntries(productItem).length">
                <VoucherTag
                  v-for="(voucherEntry, voucherIndex) in lineVoucherEntries(productItem)"
                  :key="`voucher-${productItem.id || index}-${voucherIndex}-${voucherEntry.voucherCode}`"
                  :voucherCode="voucherEntry.voucherCode"
                  v-on:removeTag="onRemoveVoucherAt(productItem, voucherIndex)"
                  class="ml-1 mb-1"
                />
              </template>
              <VoucherTag
                v-else-if="productItem.voucherCode"
                :voucherCode="productItem.voucherCode"
                v-on:removeTag="onRemoveVoucher(productItem)"
              />
            </div>

          </div>

          <div
            v-else-if="
              isItemAttachDisplay(productItem.itemType) &&
              !productItem.flexibleComboId &&
              !productItem.voucherCode
            "
            class="bill-product-discount-inner"
          >
             {{ convertPrice(productItem.discountAmount) }} ({{
              DISCOUNT_AMOUNT_TYPE_NAME[productItem.discountType]
            }} ) <span
              v-if="rowHasPromotionLabel(productItem)"
              v-b-tooltip.hover
              :title="getPromotionTooltipText(productItem)"
              class="bill-product-ctkm-badge d-inline-flex mt-1"
              > <i class="fas fa-tag"></i> <span class="bill-product-ctkm-badge__text">{{
                getPromotionBadgeText(productItem)
              }}</span
              > </span
            >
            <div
              v-if="isShowMaxValueDescription(productItem)"
              class="text-muted small"
              style="margin-top: 2px"
            >
               Chiết khấu vượt {{ productItem.originalPercentDiscountAmount }}%
            </div>

          </div>

          <div v-else>
             <span>{{ convertPrice(productItem.discountAmount) }} </span>
            <div
              class="d-flex justify-content-end flex-wrap"
              v-if="enableMultiVoucherRetail ? lineVoucherEntries(productItem).length : (productItem.voucherCode && !lineHasStackedDiscount(productItem))"
            >
              <template v-if="enableMultiVoucherRetail && lineVoucherEntries(productItem).length">
                <VoucherTag
                  v-for="(voucherEntry, voucherIndex) in lineVoucherEntries(productItem)"
                  :key="`voucher-alt-${productItem.id || index}-${voucherIndex}-${voucherEntry.voucherCode}`"
                  :voucherCode="voucherEntry.voucherCode"
                  v-on:removeTag="onRemoveVoucherAt(productItem, voucherIndex)"
                  class="ml-1 mb-1"
                />
              </template>
              <VoucherTag
                v-else-if="productItem.voucherCode && !lineHasStackedDiscount(productItem)"
                :voucherCode="productItem.voucherCode"
                v-on:removeTag="onRemoveVoucher(productItem)"
              />
            </div>

          </div>
           <span
            v-if="calculateApplyBillDiscountAmount(productItem)"
            class="text-muted small"
            style="position: absolute; right: 10px; white-space: nowrap; font-weight: 600"
            > Giảm tổng hóa đơn:<br /> {{
              convertPrice(calculateApplyBillDiscountAmount(productItem))
            }} </span
          >
        </td>

        <td
          class="td-middle text-right"
          style="width: 16%; position: relative"
        >
           <span
            v-if="
              isItemMainDisplay(productItem.itemType) || isItemAttachDisplay(productItem.itemType)
            "
            > {{ convertPrice(calculateTotalAmountBillItems(productItem)) }} </span
          > <span
            v-if="calculateApplyBillDiscountAmount(productItem)"
            class="text-muted small"
            style="position: absolute; top: 55%; right: 10px; white-space: nowrap; font-weight: 600"
            > Sau tổng giảm<br /> {{ convertPrice(calculateFinalAmountBillItem(productItem)) }}
            </span
          >
        </td>

        <td
          class="td-middle"
          style="width: 5%"
        >

          <div class="d-flex justify-content-center">
             <b-dropdown
              size="sm"
              no-caret
              right
              v-if="productItem.itemType === 1"
              :disabled="isDisabled"
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem; padding-right: 0px"
                  class="flaticon2-settings"
                ></i
                > </template
              > <!-- <b-dropdown-item
                @click="addProductGift(productItem)"
                v-if="productItem.productType !== PRODUCT_TYPE.PRODUCT_COMBO"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-gift"
                  ></i
                  > &nbsp; Thêm quà tặng </span
                > </b-dropdown-item
              > --> <b-dropdown-item
                @click.prevent="addProductGiftList(productItem)"
                v-if="productItem.productType !== PRODUCT_TYPE.PRODUCT_COMBO"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-gift"
                  ></i
                  > &nbsp; Danh sách quà tặng </span
                > </b-dropdown-item
              > <b-dropdown-item
                @click.prevent="addProductAttach(productItem)"
                v-if="
                  productItem.productType !== PRODUCT_TYPE.PRODUCT_COMBO && !applyInstallmentProgram
                "
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-tags"
                  ></i
                  > &nbsp; Thêm SP bán kèm </span
                > </b-dropdown-item
              > <b-dropdown-item
                @click.prevent="addProductWarranty(productItem)"
                v-if="productItem.productType !== PRODUCT_TYPE.PRODUCT_COMBO"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-shield-alt"
                  ></i
                  > &nbsp; Thêm gói bảo hành </span
                > </b-dropdown-item
              > <b-dropdown-item
                @click="addVoucher(productItem)"
                v-if="canAddVoucherToLine(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-tags"
                  ></i
                  > &nbsp; Thêm voucher </span
                > </b-dropdown-item
              > <b-dropdown-item
                @click="addExtraDiscountPrograms(productItem)"
                v-if="productItem.discountProgramId"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-layer-group"
                  ></i
                  > &nbsp; Thêm giảm giá </span
                > </b-dropdown-item
              > <b-dropdown-item @click="onShowPrivateNote(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="flaticon2-notepad"
                  ></i
                  > &nbsp; Thêm ghi chú </span
                > </b-dropdown-item
              > <b-dropdown-item @click="showDeleteAlert(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem; color: #d33"
                    class="flaticon2-rubbish-bin-delete-button"
                  ></i
                  > &nbsp; Xóa </span
                > </b-dropdown-item
              > </b-dropdown
            > <b-dropdown
              size="sm"
              no-caret
              right
              v-else-if="productItem.itemType === ITEM_TYPE.ATTACH"
              :disabled="isDisabled"
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-settings pr-0"
                ></i
                > </template
              > <b-dropdown-item
                @click.prevent="addProductAttach(productItem)"
                v-if="canAddNestedAttach(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-tags"
                  ></i
                  > &nbsp; Thêm SP bán kèm </span
                > </b-dropdown-item
              > <b-dropdown-item
                @click="addVoucher(productItem)"
                v-if="canAddVoucherToLine(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-tags"
                  ></i
                  > &nbsp; Thêm voucher </span
                > </b-dropdown-item
              > <b-dropdown-item @click="onShowPrivateNote(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem"
                    class="flaticon2-notepad"
                  ></i
                  > &nbsp; Thêm ghi chú </span
                > </b-dropdown-item
              > <b-dropdown-item @click="showDeleteAlert(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem; color: #d33"
                    class="flaticon2-rubbish-bin-delete-button"
                  ></i
                  > &nbsp; Xóa </span
                > </b-dropdown-item
              > </b-dropdown
            > <b-dropdown
              size="sm"
              no-caret
              right
              v-else
              :disabled="isDisabled"
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-settings pr-0"
                ></i
                > </template
              > <b-dropdown-item @click="showDeleteAlert(productItem)"
                > <span style="color: #3f4254; font-size: 12px"
                  > <i
                    style="font-size: 1rem; color: #d33"
                    class="flaticon2-rubbish-bin-delete-button"
                  ></i
                  > &nbsp; Xóa </span
                > </b-dropdown-item
              > </b-dropdown
            >
          </div>

        </td>

      </tbody>

      <tbody v-if="!billModel.billItems.length">

        <tr>

          <td
            :colspan="groupedImeiByProduct ? 8 : 7"
            class="text-center border-0"
          >

            <div style="padding: 3rem 0">
               <i
                class="fas fa-box-open"
                style="font-size: 2.5rem; color: #d1d3e0"
              ></i
              >
              <p
                class="font-weight-bolder mt-4 mb-1"
                style="color: #7e8299; font-size: 0.95rem"
              >
                Chưa có sản phẩm nào
              </p>

              <p
                class="m-0"
                style="color: #b5b5c3; font-size: 0.85rem"
              >
                Tìm kiếm và chọn sản phẩm từ thanh tìm kiếm phía trên
              </p>

            </div>

          </td>

        </tr>

      </tbody>

      <tfoot>

        <tr>

          <th
            style="text-align: end"
            :colspan="groupedImeiByProduct ? 6 : 5"
          >
             Tổng :
          </th>

          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
             {{ formattedTotalPrice }}
          </td>

          <td></td>

        </tr>

      </tfoot>

    </table>
     <AddImeiModal
      v-if="!groupedImeiByProduct"
      ref="add-imei-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :storeId="billModel.storeId"
      :productId="itemChoice.productId"
      v-on:applyImei="applyImei"
    /> <BillGiftModal
      ref="bill-gift-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :storeId="billModel.storeId"
      v-on:addGift="addGift"
    /> <BillAttachModal
      ref="bill-attach-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :productId="itemChoice.productId"
      :storeId="billModel.storeId"
      :attachDepth="attachModalDepth"
      :mainProductId="attachModalMainProductId"
      v-on:addAttach="addAttach"
    /> <BillWarrantyModal
      ref="bill-warranty-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :productId="itemChoice.productId"
      v-on:addWarranty="addWarranty"
    /> <BillNoteModal
      ref="bill-note-modal"
      :productName="itemChoice.productName"
      :note="itemChoice.note"
      v-on:addNote="onChangeNote"
    /> <FlexibleComboModal
      ref="flexible-combo"
      :flexibleComboItem="flexibleComboItem"
      :storeId="billModel.storeId"
      v-on:addComboChild="addComboChild"
    /> <VoucherApplyModal
      ref="apply-voucher-modal"
      :billItemId="itemChoice.billItemId"
      :productName="itemChoice.productName"
      :storeId="billModel.storeId"
      :productId="itemChoice.productId"
      :productAmount="itemChoice.productAmount"
      :customerMobile="billModel.customerModel.customerMobile"
      :discount-program-id="itemChoice.discountProgramId"
      v-on:applyVoucherItem="onApplyVoucherItem"
    /> <DiscountProgramStackModal
      ref="discount-program-stack-modal"
      :billItemId="extraProgramContext.billItemId"
      :productName="extraProgramContext.productName"
      :productId="extraProgramContext.productId"
      :storeId="billModel.storeId"
      :mainProgramId="extraProgramContext.mainProgramId"
      :attachProductIds="extraProgramContext.attachProductIds"
      :selectedExtraIds="extraProgramContext.selectedExtraIds"
      v-on:apply="onApplyExtraDiscountPrograms"
    /> <BillGiftProductModal
      ref="bill-gift-product-modal"
      :billItemId="itemChoice.id"
      :productName="itemChoice.productName"
      :storeId="billModel.storeId"
      :productId="itemChoice.productId"
      :listGiftProducts="itemChoice.listGiftProducts"
      v-on:addGiftList="onAddGiftList"
    /> <ImportImei
      ref="import-imei-bulk-modal"
      @saveData="onImportBulkImeis"
    /> <b-modal
      ref="bulk-imei-invalid-modal"
      hide-footer
      title="Chi tiết IMEI import lỗi"
      size="lg"
      >
      <p class="mb-2"> Có {{ importInvalidRows.length }} dòng IMEI cần kiểm tra lại. </p>
       <b-table
        :fields="importInvalidFields"
        :items="importInvalidRows"
        bordered
        hover
        small
        responsive
        > </b-table
      >
      <div class="text-right mt-3">
         <b-button
          variant="outline-primary"
          size="sm"
          class="mr-2"
          @click="downloadInvalidRowsCsv"
          > <i class="far fa-file-excel mr-1"></i> Tải file lỗi </b-button
        > <b-button
          variant="secondary"
          size="sm"
          @click="$refs['bulk-imei-invalid-modal'].hide()"
          >Đóng</b-button
        >
      </div>
       </b-modal
    >
  </div>

</template>

<script>
  import ApiService from '@/core/services/api.service'
  import {
    createDebouncedProductSearchExecutor,
    isProductSearchSkipped,
    searchByImeiForSale,
    searchProductsForSale,
    unwrapProductSearchData,
  } from '@/utils/productSearch'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import Swal from 'sweetalert2'
  import { v4 as uuidv4 } from 'uuid'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import { minLength } from 'vuelidate/lib/validators'
  import { validationMixin } from 'vuelidate'
  import { sumBy } from 'lodash'
  import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name'
  import calculateMixin from '@/view/mixins/calculate.mixins.js'
  import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
  import AddImeiModal from './AddImeiModal.vue'
  import BillGiftModal from './BillGiftModal.vue'
  import BillAttachModal from './BillAttachModal.vue'
  import BillWarrantyModal from './BillWarrantyModal.vue'
  import BillNoteModal from './BillNoteModal.vue'
  import BillGiftProductModal from './BillGiftProductModal.vue'
  import ImportImei from '@/view/components/stock-slips/import-excels/ImportImei.vue'
  import { PRODUCT_TYPE, ITEM_TYPE, AMOUNT_TYPE, BILL_TYPE } from '@/utils/enum'
  import { cmdUrl } from '@/utils/apiUrl'
  import { TIME_TRIGGER } from '@/utils/constants'
  import permissionMixin from '@/view/mixins/permission.mixin'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import {
    makeToastFaile,
    makeToastSuccess,
    cloneDeep,
    convertPrice,
    calculateDiscountAmount,
    unMaskPrice,
  } from '@/utils/common'
  import sortListBillItem from './helpers/sortListBillItem'
  import {
    countAttachCascadeRemove,
    findMainProductIdForAttachRow,
    resolveAttachLevel,
  } from './helpers/nestAttachItems'
  import FlexibleComboModal from './FlexibleComboModal.vue'
  import VoucherApplyModal from '@/view/components/voucher/VoucherApplyModal.vue'
  import VoucherTag from '@/view/components/voucher/VoucherTag.vue'
  import ImeiInputModal from '@/view/components/stock-slips/ImeiInputModal.vue'
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  import {
    labelsFromDiscountProgramApi,
    getPromotionBadgeText,
    getPromotionTooltipText,
    rowHasPromotionLabel,
  } from '@/utils/discountProgramDisplay'
  import {
    applyStackedAmountsToLineDisplayFields,
    clearSplitAmountFields,
    hasVoucherOnLine,
    programOnlyLineDiscountRounded,
    roundMoneyToThousand,
    totalLineDiscountMoneyRounded,
    setProgramOnlySplitAmounts,
    isStackedDiscountLine,
  } from '@/utils/voucherDiscountStack'
  import {
    collectProgramIds,
    serializeExtraDiscountProgramIds,
    parseExtraDiscountProgramIds,
    computeStackedProgramAmount,
  } from '@/utils/discountProgramStack'
  import DiscountProgramStackModal from './DiscountProgramStackModal.vue'
  import { ENABLE_MULTI_VOUCHER_RETAIL, MAX_VOUCHERS_PER_LINE } from '@/constants/multiVoucherRetail'
  import {
    calculateRetailBillTotalAmount,
    syncLegacyVoucherFieldsFromArray,
    hydrateLineVouchersFromApi,
  } from '@/utils/billTotalAmount'
  import { validateLineVouchers } from '@/services/voucher/voucherV2.api'

  const SEARCH_TYPE = {
    PRODUCT: 1,
    IMEI: 2,
    FLEXIBLE_COMBO: 3,
  }

  export default {
    props: {
      billModel: Object,
      groupedImeiByProduct: {
        type: Boolean,
        default: false,
      },
      applyInstallmentProgram: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [validationMixin, calculateMixin, permissionMixin],
    validations: {
      itemChoice: {
        imeiCode: {
          minLength: minLength(3),
        },
      },
    },
    data() {
      return {
        PRODUCT_TYPE,
        ITEM_TYPE,
        DISCOUNT_AMOUNT_TYPE_NAME,
        SEARCH_TYPE,
        productSearch: {
          searchType: SEARCH_TYPE.PRODUCT,
          placeHolder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
          searchName: null,
        },
        optionProductSearchType: [
          {
            id: 1,
            name: 'Tìm sản phẩm',
          },
          {
            id: 2,
            name: 'Tìm IMEI',
          },
          {
            id: 3,
            name: 'Tìm bộ combo',
          },
        ],
        isOpenProductSearch: false,
        validateDiscountArr: [],
        messageErrorDiscount: 'CK vượt giá trị SP',
        DISCOUNT_AMOUNT_TYPE: AMOUNT_TYPE,
        itemChoice: {
          id: 0,
          name: '',
          productId: '',
          imeiCode: '',
          price: 0,
          quantity: 0,
          discount: 0,
          totalPrice: 0,
          billItemId: null,
          discountProgramId: null,
        },
        extraProgramContext: {
          billItemId: null,
          productName: '',
          productId: '',
          mainProgramId: null,
          attachProductIds: [],
          selectedExtraIds: null,
        },
        flexibleComboItem: {
          id: null,
          name: '',
          code: '',
          discountAmount: 0,
          discountType: AMOUNT_TYPE.MONEY,
          discountTypeName: '$',
          listItem: [],
          applyProducts: [],
          applyCategories: [],
        },
        textInfo: {
          alignItems: 'center',
          display: 'flex',
          marginTop: '8px',
        },
        importInvalidRows: [],
        attachModalDepth: 1,
        attachModalMainProductId: null,
        importInvalidFields: [
          {
            key: 'rowIndex',
            label: 'Dòng',
            thStyle: { width: '10%', textAlign: 'center' },
            tdClass: 'text-center',
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { width: '35%' },
          },
          {
            key: 'error',
            label: 'Lỗi',
          },
        ],
      }
    },
    components: {
      Treeselect,
      BInputNumber,
      AddImeiModal,
      BillGiftModal,
      BillAttachModal,
      BillNoteModal,
      ProductImage,
      FlexibleComboModal,
      VoucherApplyModal,
      VoucherTag,
      BillWarrantyModal,
      BillGiftProductModal,
      ImportImei,
      ImeiInputModal,
      DiscountProgramStackModal,
    },
    mounted() {
      this.normalizeGroupedImeiFields()
    },
    computed: {
      totalBillItemsAmount() {
        return this.billModel.billItems
          .filter(this.isNonGiftItem)
          .reduce((total, item) => total + this.calculateTotalAmountBillItems(item), 0)
      },
      totalBillItemsQuantity() {
        return this.billModel.billItems
          .filter(this.isNonGiftItem)
          .reduce((total, item) => total + Number(item.quantity || 0), 0)
      },
      formattedTotalPrice() {
        const totalPrice = this.totalBillItemsAmount
        return convertPrice(totalPrice)
      },
      isDisabled() {
        return (
          !this.billModel.storeId ||
          !this.billModel.editable ||
          this.billModel.hasExchange
        )
      },
      isCanEditPrice() {
        if (this.isDisabled) {
          return false
        }

        return this.checkPermission('BILL_EDIT_PRODUCT_PRICE')
      },
      isCanEditDiscount() {
        if (this.isDisabled) {
          return false
        }

        return this.checkPermission('BILL_ALLOW_DISCOUNT')
      },
      showBulkImeiImportButton() {
        return this.billModel.billType === BILL_TYPE.WHOLESALE_INVOICE
      },
      enableMultiVoucherRetail() {
        return (
          ENABLE_MULTI_VOUCHER_RETAIL &&
          this.billModel.billType === BILL_TYPE.RETAIL_INVOICE
        )
      },
    },
    created() {
      this._productSearchLoader = createDebouncedProductSearchExecutor(
        async (searchQuery, options) => {
          const type = this.productSearch.searchType
          return this.searchProductAPI(searchQuery, type, options)
        },
      )
    },
    beforeDestroy() {
      this._productSearchLoader?.cancel?.()
    },
    watch: {
      'productSearch.searchType'(type) {
        const name = [
          '',
          'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
          'Tìm kiếm theo mã IMEI',
          'Tìm kiếm theo bộ combo',
        ]
        this.productSearch.placeHolder = name[type]
      },
      'billModel.storeId': {
        handler() {
          if (!this.billModel.id) {
            this.billModel.billItems = []
          }
        },
        deep: true,
      },
      'billModel.billItems': {
        deep: true,
        handler(items) {
          if (!this.groupedImeiByProduct) return
          this.normalizeGroupedImeiFields()
          ;(items || []).forEach((item) => {
            if (
              item.productType === PRODUCT_TYPE.PRODUCT_IMEI &&
              item.itemType === ITEM_TYPE.MAIN &&
              item.IMEI !== undefined &&
              item.IMEI !== null
            ) {
              item.imeiCode = item.IMEI
            }
          })
        },
      },
    },
    methods: {
      convertPrice,
      lineVoucherEntries(line) {
        return (line?.vouchers || []).filter(
          (entry) => entry && String(entry.voucherCode || '').trim(),
        )
      },
      resolveBillItemForVoucher(billItemId) {
        const targetId = billItemId || this.itemChoice.billItemId || this.itemChoice.id
        if (!targetId) return null
        return this.billModel.billItems.find((billItem) => billItem.id === targetId) || null
      },
      getPromotionBadgeText,
      getPromotionTooltipText,
      rowHasPromotionLabel,
      onSearchChange(searchQuery) {
        if (searchQuery.length > 1 && !this.isOpenProductSearch) {
          this.isOpenProductSearch = true
        } else if (searchQuery.length === 0) {
          this.isOpenProductSearch = false
        }
      },
      isItemMainDisplay(value) {
        return value === ITEM_TYPE.MAIN ? true : false
      },
      isItemAttachDisplay(value) {
        return value === ITEM_TYPE.ATTACH ? true : false
      },
      lineHasStackedDiscount(line) {
        return isStackedDiscountLine(line)
      },
      stackedLineDiscountTotal(line) {
        return (Number(line.discountProgramAmount) || 0) + (Number(line.voucherAmount) || 0)
      },
      isNonGiftItem(item) {
        return item.itemType !== ITEM_TYPE.GIFT
      },
      calculateApplyBillDiscountAmount(productItem) {
        const billDiscountAmount = calculateDiscountAmount(
          this.billModel.discountAmount,
          this.billModel.discountType,
          this.totalBillItemsAmount,
        )
        const totalAmountItem = this.calculateTotalAmountBillItems(productItem)
        const itemRate = totalAmountItem / this.totalBillItemsAmount
        const applyBillDiscountAmount = billDiscountAmount * itemRate
        return Math.round(applyBillDiscountAmount / 1000) * 1000
      },
      calculateAfterDiscountAmount(item) {
        const sellingPrice = item.sellingPriceMask || 0
        const discountAmount = this.calculateDiscountAmountByMaxValue(item, sellingPrice)

        const applyBillDiscountAmount = this.calculateApplyBillDiscountAmount(item)

        return sellingPrice - discountAmount - applyBillDiscountAmount
      },
      calculateTotalAmountBillItems(item) {
        const sellingPrice = item.sellingPriceMask || 0
        const quantity = item.quantity || 0
        const discountAmount = this.calculateDiscountAmountByMaxValue(item, sellingPrice)
        let totalAmountItem = 0

        if (quantity > 0) {
          totalAmountItem = (Number(sellingPrice) - Number(discountAmount)) * Number(quantity)
        }

        return totalAmountItem
      },
      calculateDiscountAmountByMaxValue(item, sellingPrice) {
        const discountAmount = this.calculateDiscountAmount(
          item.discountAmount || 0,
          item.discountType,
          sellingPrice,
        )

        const maxValue = Number(item.maxValue || 0)
        if (!maxValue || maxValue <= 0) {
          return discountAmount
        }

        return Math.min(Number(discountAmount), maxValue)
      },
      calculateFinalAmountBillItem(item) {
        const applyBillDiscountAmount = this.calculateApplyBillDiscountAmount(item)

        const itemAmount = this.calculateTotalAmountBillItems(item)
        return itemAmount - applyBillDiscountAmount * item.quantity
      },
      getProductPriceByBillType(product) {
        const sellingPrice = product.sellingPrice || 0
        if (this.billModel.billType === BILL_TYPE.WHOLESALE_INVOICE) {
          return product.wholesalePrice || sellingPrice
        }
        return sellingPrice
      },
      loadOptionProducts({ action, searchQuery, callback }) {
        if (action !== ASYNC_SEARCH) return
        const type = this.productSearch.searchType
        this.productSearchTemp = searchQuery
        this._productSearchLoader.run(searchQuery, (error, result) => {
          if (error) {
            callback(error, [])
            return
          }
          const resultData = this.extractResultData(result, type)
          const optionProduct = (resultData || []).map((element) => {
            const sellingPriceMask = this.getProductPriceByBillType(element)
            if (type === PRODUCT_TYPE.PRODUCT || type === SEARCH_TYPE.FLEXIBLE_COMBO) {
              return {
                id: this.$uuid.v4(),
                label: element.productName,
                ...element,
                sellingPriceMask,
              }
            }
            return {
              id: this.$uuid.v4(),
              label: element.productName,
              imeiCode: element.imeiCode,
              ...element,
              sellingPriceMask,
            }
          })
          callback(null, optionProduct)
        })
      },
      extractResultData(result, type) {
        if (type === SEARCH_TYPE.FLEXIBLE_COMBO) {
          return result
        }
        return result.data || []
      },
      async searchProductAPI(searchQuery, type, options = {}) {
        switch (type) {
          case SEARCH_TYPE.PRODUCT:
            return this.fetchProduct(searchQuery, options)
          case SEARCH_TYPE.IMEI:
            return this.fetchProductImei(searchQuery, options)
          case SEARCH_TYPE.FLEXIBLE_COMBO:
            return this.searchFlexibleCombo(searchQuery)
          default:
            return { data: [] }
        }
      },
      showBulkImportImeiModal() {
        if (!this.billModel.storeId) {
          return makeToastFaile('Vui lòng chọn cửa hàng trước khi nhập IMEI từ excel')
        }
        this.$refs['import-imei-bulk-modal'].showModal()
      },
      normalizeImportInvalidRows(rows) {
        return (rows || []).map((row) => {
          return {
            rowIndex: Number(row?.rowIndex || 0),
            imeiCode: String(row?.imeiCode == null ? '' : row.imeiCode),
            error: row?.error || 'Dữ liệu IMEI không hợp lệ',
          }
        })
      },
      showImportInvalidRowsModal(rows) {
        this.importInvalidRows = this.normalizeImportInvalidRows(rows)
        if (this.importInvalidRows.length > 0) {
          this.$refs['bulk-imei-invalid-modal'].show()
        }
      },
      escapeCsvCell(value) {
        const text = String(value == null ? '' : value)
        return `"${text.replace(/"/g, '""')}"`
      },
      downloadInvalidRowsCsv() {
        if (!this.importInvalidRows.length) {
          return makeToastFaile('Không có dữ liệu lỗi để tải')
        }
        const header = ['rowIndex', 'IMEI', 'error']
        const lines = [header.join(',')]
        this.importInvalidRows.forEach((row) => {
          lines.push(
            [
              this.escapeCsvCell(row.rowIndex),
              this.escapeCsvCell(row.imeiCode),
              this.escapeCsvCell(row.error),
            ].join(','),
          )
        })
        const content = '\uFEFF' + lines.join('\n')
        const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'imei-import-invalid-rows.csv'
        link.click()
        URL.revokeObjectURL(link.href)
      },
      async applyGroupedBulkImeiImport(validProducts, invalidRows, imeiList) {
        let countStt = this.billModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.MAIN,
        ).length

        const existingImeiSet = new Set()
        this.billModel.billItems.forEach((item) => {
          this.parseImeiCodes(item.imeiCode).forEach((c) => existingImeiSet.add(c))
        })

        const duplicateImeis = []
        const groups = new Map()

        validProducts.forEach((product) => {
          const imeiCode = String(product.imeiCode || '').trim()
          if (!imeiCode) return
          if (existingImeiSet.has(imeiCode)) {
            duplicateImeis.push(imeiCode)
            return
          }
          const pid = product.productId
          if (!groups.has(pid)) {
            groups.set(pid, { template: product, imeis: [] })
          }
          groups.get(pid).imeis.push(imeiCode)
          existingImeiSet.add(imeiCode)
        })

        const newItems = []
        const mergedExisting = []

        groups.forEach(({ template, imeis }) => {
          const uniqueImeis = [...new Set(imeis)]
          const existing = this.billModel.billItems.find(
            (i) =>
              i.itemType === ITEM_TYPE.MAIN &&
              i.productId === template.productId &&
              i.productType === PRODUCT_TYPE.PRODUCT_IMEI,
          )

          if (existing) {
            const cur = this.parseImeiCodes(existing.IMEI || existing.imeiCode)
            uniqueImeis.forEach((code) => {
              if (cur.includes(code)) duplicateImeis.push(code)
            })
            const toAdd = uniqueImeis.filter((code) => !cur.includes(code))
            if (!toAdd.length) return
            const merged = [...cur, ...toAdd]
            const mergedStr = merged.join(',')
            this.$set(existing, 'IMEI', mergedStr)
            existing.imeiCode = mergedStr
            existing.quantity = merged.length
            mergedExisting.push({
              item: existing,
              gifts: template.gifts || [],
            })
            return
          }

          const item = this.handleBillItemSelected(template, ++countStt)
          const mergedStr = uniqueImeis.join(',')
          this.$set(item, 'IMEI', mergedStr)
          item.imeiCode = mergedStr
          item.quantity = uniqueImeis.length
          newItems.push({
            item,
            gifts: template.gifts || [],
          })
        })

        const totalNewLines = newItems.length
        if (newItems.length) {
          this.billModel.billItems.push(...newItems.map((e) => e.item))
        }
        if (newItems.length || mergedExisting.length) {
          this.billModel.billItems = sortListBillItem(this.billModel.billItems)
        }

        const allEntries = [...newItems, ...mergedExisting]
        for (const entry of allEntries) {
          this.autoSelectGift(entry.gifts, entry.item.id)
          await this.getProductDiscount(entry.item)
        }

        if (!allEntries.length) {
          const duplicateRows = duplicateImeis.map((imeiCode) => {
            return {
              rowIndex: imeiList.findIndex((x) => x === imeiCode) + 1,
              imeiCode,
              error: 'IMEI đã tồn tại trên hóa đơn',
            }
          })
          const modalRows = [...invalidRows, ...duplicateRows]
          if (modalRows.length > 0) {
            this.showImportInvalidRowsModal(modalRows)
          }
          const errorHint =
            invalidRows.length > 0
              ? ` Có ${invalidRows.length} dòng không hợp lệ.`
              : duplicateImeis.length > 0
                ? ` ${duplicateImeis.length} IMEI đã tồn tại trên hóa đơn.`
                : ''
          return makeToastFaile(`Không có IMEI hợp lệ để thêm.${errorHint}`)
        }

        const extraInfo = []
        if (invalidRows.length > 0) {
          extraInfo.push(`${invalidRows.length} dòng lỗi`)
        }
        if (duplicateImeis.length > 0) {
          extraInfo.push(`${duplicateImeis.length} IMEI trùng trên hóa đơn`)
        }
        const suffix = extraInfo.length ? ` (${extraInfo.join(', ')})` : ''
        const msgParts = []
        if (totalNewLines > 0) msgParts.push(`thêm ${totalNewLines} dòng mới`)
        if (mergedExisting.length > 0) {
          msgParts.push(`ghép IMEI vào ${mergedExisting.length} dòng có sẵn`)
        }
        makeToastSuccess(`Đã nhập IMEI — ${msgParts.join(', ')} (gom theo sản phẩm)${suffix}`)
        const duplicateRows = duplicateImeis.map((imeiCode) => {
          return {
            rowIndex: imeiList.findIndex((x) => x === imeiCode) + 1,
            imeiCode,
            error: 'IMEI đã tồn tại trên hóa đơn',
          }
        })
        const modalRows = [...invalidRows, ...duplicateRows]
        if (modalRows.length > 0) {
          this.showImportInvalidRowsModal(modalRows)
        }
      },
      async onImportBulkImeis(importItems) {
        const imeiList = (importItems || []).map((row) =>
          String(row?.imeiCode == null ? '' : row.imeiCode).trim(),
        )

        if (!imeiList.length) {
          return makeToastFaile('Vui lòng nhập dữ liệu IMEI từ file excel')
        }
        if (!this.billModel.storeId) {
          return makeToastFaile('Vui lòng chọn cửa hàng trước khi nhập IMEI từ excel')
        }

        try {
          const payload = {
            storeId: this.billModel.storeId,
            imeiList,
          }
          const response = await ApiService.post('v1/product-search/validate-import-imei', payload)
          const result = response?.data?.data || {}
          const validProducts = result.validProducts || []
          const invalidRows = result.invalidRows || []

          if (this.groupedImeiByProduct) {
            await this.applyGroupedBulkImeiImport(validProducts, invalidRows, imeiList)
            return
          }

          let countStt = this.billModel.billItems.filter(
            (item) => item.itemType === ITEM_TYPE.MAIN,
          ).length
          const existingImeiSet = new Set(
            this.billModel.billItems
              .map((item) => String(item.imeiCode || '').trim())
              .filter((code) => !!code),
          )
          const duplicateImeis = []
          const addEntries = []

          validProducts.forEach((product) => {
            const imeiCode = String(product.imeiCode || '').trim()
            if (!imeiCode) return
            if (existingImeiSet.has(imeiCode)) {
              duplicateImeis.push(imeiCode)
              return
            }

            const item = this.handleBillItemSelected(product, ++countStt)
            item.imeiCode = imeiCode
            existingImeiSet.add(imeiCode)
            addEntries.push({
              item,
              gifts: product.gifts || [],
            })
          })

          if (addEntries.length) {
            this.billModel.billItems.push(...addEntries.map((entry) => entry.item))
            this.billModel.billItems = sortListBillItem(this.billModel.billItems)

            for (const entry of addEntries) {
              this.autoSelectGift(entry.gifts, entry.item.id)
              await this.getProductDiscount(entry.item)
            }
          }

          if (!addEntries.length) {
            const duplicateRows = duplicateImeis.map((imeiCode) => {
              return {
                rowIndex: imeiList.findIndex((x) => x === imeiCode) + 1,
                imeiCode,
                error: 'IMEI đã tồn tại trên hóa đơn',
              }
            })
            const modalRows = [...invalidRows, ...duplicateRows]
            if (modalRows.length > 0) {
              this.showImportInvalidRowsModal(modalRows)
            }
            const errorHint =
              invalidRows.length > 0
                ? ` Có ${invalidRows.length} dòng không hợp lệ.`
                : duplicateImeis.length > 0
                  ? ` ${duplicateImeis.length} IMEI đã tồn tại trên hóa đơn.`
                  : ''
            return makeToastFaile(`Không có IMEI hợp lệ để thêm.${errorHint}`)
          }

          const extraInfo = []
          if (invalidRows.length > 0) {
            extraInfo.push(`${invalidRows.length} dòng lỗi`)
          }
          if (duplicateImeis.length > 0) {
            extraInfo.push(`${duplicateImeis.length} IMEI trùng trên hóa đơn`)
          }
          const suffix = extraInfo.length ? ` (${extraInfo.join(', ')})` : ''
          makeToastSuccess(`Đã thêm ${addEntries.length} sản phẩm từ file IMEI${suffix}`)
          const duplicateRows = duplicateImeis.map((imeiCode) => {
            return {
              rowIndex: imeiList.findIndex((x) => x === imeiCode) + 1,
              imeiCode,
              error: 'IMEI đã tồn tại trên hóa đơn',
            }
          })
          const modalRows = [...invalidRows, ...duplicateRows]
          if (modalRows.length > 0) {
            this.showImportInvalidRowsModal(modalRows)
          }
        } catch (error) {
          const message =
            error?.response?.data?.message || 'Không thể validate danh sách IMEI từ excel'
          makeToastFaile(message)
        }
      },
      async fetchProduct(textSearch, options = {}) {
        this.listProduct = []
        const params = {
          searchText: textSearch,
          storeId: this.billModel.storeId,
        }
        const response = await searchProductsForSale(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      async fetchProductImei(textSearch, options = {}) {
        const params = {
          searchText: textSearch,
          storeId: this.billModel.storeId,
        }
        const response = await searchByImeiForSale(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      searchFlexibleCombo(textSearch) {
        if (isProductSearchSkipped(textSearch)) {
          return Promise.resolve([])
        }
        const params = {
          textSearch: textSearch ? textSearch.trim() : null,
          storeId: this.billModel.storeId,
        }
        return ApiService.query('v1/flexible-combo/search', { params }).then(({ data }) => {
          const products = data.data
          return products.map((product) => {
            return {
              productId: product.id,
              productName: product.name,
              productCode: product.code,
              productNameVat: '',
              discountAmount: product.discountAmount,
              discountType: product.discountType,
              discountTypeName: product.discountTypeName,
              productType: 3,
              imeiCode: '',
              listAccessoryBonus: [],
              listAccessoryPromotion: [],
              quantityInStock: product.inStockQuantity ? product.inStockQuantity : 0,
              listedPrice: 0,
              listItem: product.listItem,
              applyCategories: product.applyCategories,
              applyProducts: product.applyProducts,
            }
          })
        })
      },
      async onSelectProduct(node) {
        this.isOpenProductSearch = false
        if (this.productSearch.searchType === SEARCH_TYPE.FLEXIBLE_COMBO) {
          this.flexibleComboItem.name = node.productName
          this.flexibleComboItem.id = node.productId
          this.flexibleComboItem.code = node.productCode
          this.flexibleComboItem.discountAmount = node.discountAmount
          this.flexibleComboItem.discountType = node.discountType
          this.flexibleComboItem.listItem = node.listItem
          this.flexibleComboItem.applyCategories = node.applyCategories
          this.flexibleComboItem.applyProducts = node.applyProducts
          this.showModalFlexibleCombo()
          return
        }

        if (node.productType !== PRODUCT_TYPE.PRODUCT_SERVICE && node.inStockQuantity <= 0) {
          makeToastFaile('Sản phẩm đã hết hàng')
          return
        }

        if (this.groupedImeiByProduct && node.productType === PRODUCT_TYPE.PRODUCT_IMEI) {
          const imeiFromNode = String(node.imeiCode || '').trim()
          const existing = this.billModel.billItems.find(
            (i) =>
              i.itemType === ITEM_TYPE.MAIN &&
              i.productId === node.productId &&
              i.productType === PRODUCT_TYPE.PRODUCT_IMEI,
          )
          if (existing) {
            const codes = this.parseImeiCodes(existing.IMEI || existing.imeiCode)
            if (imeiFromNode) {
              if (codes.includes(imeiFromNode)) {
                makeToastFaile('IMEI đã có trong dòng sản phẩm này')
                return
              }
              codes.push(imeiFromNode)
            }
            const merged = codes.join(',')
            this.$set(existing, 'IMEI', merged)
            existing.imeiCode = merged
            existing.quantity = codes.length
            await this.getProductDiscount(existing)
            return
          }
        }

        let countStt = this.billModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.MAIN,
        ).length

        const item = this.handleBillItemSelected(node, ++countStt)
        this.billModel.billItems.push(item)
        this.autoSelectGift(node.gifts, item.id)
        await this.getProductDiscount(item)
      },
      handleBillItemSelected(item, stt) {
        // eslint-disable-next-line no-unused-vars
        const { gifts, ...rest } = item
        const itemSelected = cloneDeep(rest)
        const sellingPrice = this.getProductPriceByBillType(item)

        itemSelected.sellingPrice = sellingPrice
        itemSelected.itemType = ITEM_TYPE.MAIN
        itemSelected.quantity = 1
        itemSelected.sellingPriceMask = sellingPrice
        itemSelected.stt = stt
        itemSelected.note = ''
        itemSelected.discountType = 1
        itemSelected.discountAmount = 0
        itemSelected.isPrivateNote = false
        itemSelected.popPrivateNote = ''
        itemSelected.gifts = item.gifts || []
        if (this.groupedImeiByProduct && itemSelected.productType === PRODUCT_TYPE.PRODUCT_IMEI) {
          const imeiVal = String(item.imeiCode || item.IMEI || '').trim()
          this.$set(itemSelected, 'IMEI', imeiVal)
          itemSelected.imeiCode = imeiVal
          const cnt = this.parseImeiCodes(imeiVal).length
          itemSelected.quantity = cnt
        }
        return itemSelected
      },
      parseImeiCodes(imeiStr) {
        if (!imeiStr || !String(imeiStr).trim()) return []
        return String(imeiStr)
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      },
      normalizeGroupedImeiFields() {
        if (!this.groupedImeiByProduct || !this.billModel?.billItems) return
        this.billModel.billItems.forEach((item) => {
          if (item.productType === PRODUCT_TYPE.PRODUCT_IMEI && item.itemType === ITEM_TYPE.MAIN) {
            if (item.IMEI === undefined || item.IMEI === null) {
              this.$set(item, 'IMEI', item.imeiCode || '')
            }
          }
        })
      },
      addProductGift(item) {
        this.itemChoice.id = item.id
        this.itemChoice.productId = item.productId
        this.itemChoice.productName = item.productName
        setTimeout(() => {
          this.$refs['bill-gift-modal'].showModal()
        }, TIME_TRIGGER)
      },
      getAttachIndentStyle(productItem) {
        if (productItem.itemType !== ITEM_TYPE.ATTACH) {
          return {}
        }
        const level = resolveAttachLevel(productItem)
        if (level === 2) {
          return { paddingLeft: '2.5rem' }
        }
        return { paddingLeft: '1.25rem' }
      },
      canAddNestedAttach(productItem) {
        return (
          productItem.itemType === ITEM_TYPE.ATTACH &&
          resolveAttachLevel(productItem) === 1 &&
          !this.applyInstallmentProgram
        )
      },
      addProductAttach(item) {
        this.itemChoice.id = item.id
        this.itemChoice.productId = item.productId
        this.itemChoice.productName = item.productName
        this.itemChoice.attachItems = item.attachItems || []
        const isFromAttach = item.itemType === ITEM_TYPE.ATTACH
        this.attachModalDepth = isFromAttach ? 2 : 1
        if (isFromAttach) {
          this.attachModalMainProductId =
            findMainProductIdForAttachRow(item, this.billModel.billItems) || item.productId
        } else {
          this.attachModalMainProductId = item.productId
        }
        setTimeout(() => {
          this.$refs['bill-attach-modal'].showModal()
        }, TIME_TRIGGER)
      },
      addProductGiftList(item) {
        this.itemChoice.id = item.id
        this.itemChoice.productId = item.productId
        this.itemChoice.productName = item.productName
        this.itemChoice.listGiftProducts = item.giftProducts || []
        setTimeout(() => {
          this.$refs['bill-gift-product-modal'].showModal()
        }, TIME_TRIGGER)
      },
      showWarningAlert: function (text) {
        return Swal.fire({
          title: 'Xoá sản phẩm!',
          text: text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Đồng ý',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        })
      },
      getIndexBillItems(id) {
        const index = this.billModel.billItems.findIndex((item) => item.id === id)
        if (index < 0) {
          makeToastFaile(`Không tìm thấy ${id} trong danh sách`)
          throw new Error(`Không tìm thấy ${id} trong danh sách`)
        }
        return index
      },
      async showDeleteAlert(product) {
        const text = `Bạn muốn xoá sản phẩm ${product.productName} ra khỏi danh sách`
        const alert = await this.showWarningAlert(text)

        if (alert.isConfirmed) {
          const index = this.getIndexBillItems(product.id)

          if (index > -1) {
            const removeCount = countAttachCascadeRemove(product.id, this.billModel.billItems)
            this.billModel.billItems.splice(index, removeCount)
            this.numberedBillItems()
          }
        }
      },
      numberedBillItems() {
        let count = 1
        return this.billModel.billItems.map((item) => {
          if (item.itemType === ITEM_TYPE.MAIN) {
            item.stt = count
            count++
          }
          return item
        })
      },
      onShowPrivateNote(item) {
        this.itemChoice.id = item.id
        this.itemChoice.productName = item.productName
        const line = this.billModel.billItems.find(
          (row) => row.id === item.id || String(row.id) === String(item.id),
        )
        const latestNote =
          line != null
            ? line.note == null
              ? ''
              : String(line.note)
            : item.note == null
              ? ''
              : String(item.note)
        this.$set(this.itemChoice, 'note', latestNote)
        setTimeout(() => {
          this.$refs['bill-note-modal'].showModal(latestNote)
        }, TIME_TRIGGER)
      },
      changeProduct(item, action) {
        console.log('changeProduct: ', item, action)
      },
      onChangeDiscountType(productItem, discountType) {
        productItem.discountType = discountType
        this.$set(productItem, 'isOverMaxValue', false)
      },
      isShowMaxValueDescription(productItem) {
        return (
          rowHasPromotionLabel(productItem) &&
          Number(productItem.maxValue) > 0 &&
          Number(productItem.isOverMaxValue) === 1
        )
      },
      addProductImei(productItem) {
        this.itemChoice.id = productItem.id
        this.itemChoice.productId = productItem.productId
        this.itemChoice.productName = productItem.productName
        setTimeout(() => {
          this.$refs['add-imei-modal'].showModal(this.itemChoice.productId)
        }, TIME_TRIGGER)
      },
      applyImei(imeiCode) {
        const productItemIndex = this.billModel.billItems.findIndex(
          (item) => item.id === this.itemChoice.id,
        )
        if (productItemIndex >= 0) {
          this.billModel.billItems[productItemIndex].imeiCode = imeiCode
          this.itemChoice.imeiCode = imeiCode
        }
      },
      addAttach(attachs) {
        const attachItems = attachs.map((item) => {
          const discountProgramId =
            item.discountProgramId != null && item.discountProgramId !== ''
              ? item.discountProgramId
              : item.programId != null && item.programId !== ''
                ? item.programId
                : null
          const promotionProgramId =
            item.promotionProgramId || item.accessoryGroupId || discountProgramId
          const attachLevel = item.attachLevel || this.attachModalDepth || 1
          return {
            id: item.id,
            itemType: item.itemType,
            belongBillDetailId: item.belongBillDetailId,
            productId: item.productId,
            productName: item.productName,
            barCode: item.barCode,
            productCode: item.productCode,
            productType: item.productType,
            sellingPrice: item.sellingPrice,
            sellingPriceMask: item.sellingPrice,
            quantity: 1,
            discountType: item.discountType,
            discountAmount: item.discountValue,
            totalPrice: item.finalSellingPrice,
            imeiCode: '',
            promotionProgramCode: item.promotionProgramCode || item.accessoryGroupCode || '',
            promotionProgramName: item.promotionProgramName || '',
            promotionProgramId,
            accessoryGroupId: item.accessoryGroupId || promotionProgramId,
            accessoryGroupCode: item.accessoryGroupCode || item.promotionProgramCode || '',
            attachLevel,
            hasNestedAttach: item.hasNestedAttach ?? false,
            discountProgramId,
            maxValue: item.maxValue,
            isOverMaxValue: item.isOverMaxValue,
            note: '',
            checked: item.checked,
          }
        })
        this.billModel.billItems.push(...attachItems)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      addGift(gifts) {
        const giftItems = gifts.map((item) => {
          return {
            id: item.id,
            itemType: item.billItemType,
            belongBillDetailId: item.belongBillDetailId,
            productId: item.productId,
            productName: item.productName,
            productCode: item.productCode,
            barCode: item.barCode,
            productType: item.productType,
            sellingPrice: item.sellingPrice,
            quantity: item.quantity,
            discountType: item.discountType,
            discountAmount: item.discountAmount,
            totalPrice: item.totalPrice,
            imeiCode: item.imeiCode,
            note: item.note,
            checked: item.checked,
          }
        })
        this.billModel.billItems.push(...giftItems)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      onChangeNote(note) {
        const targetId = this.itemChoice.id
        const billItem = this.billModel.billItems.find(
          (item) => item.id === targetId || String(item.id) === String(targetId),
        )
        if (!billItem) {
          makeToastFaile('Không tìm thấy dòng sản phẩm để lưu ghi chú.')
          return
        }
        this.$set(billItem, 'note', note == null ? '' : String(note))
      },
      autoSelectGift(gifts, billItemId) {
        if (!gifts || gifts.length === 0) {
          return
        }

        const giftItems = gifts.map((item) => {
          return {
            id: uuidv4(),
            itemType: ITEM_TYPE.GIFT,
            belongBillDetailId: billItemId,
            productId: item.productId,
            productName: item.productName,
            productCode: item.productCode,
            barCode: item.barCode,
            productType: item.productType,
            sellingPrice: item.sellingPrice,
            quantity: 1,
            discountType: AMOUNT_TYPE.MONEY,
            discountAmount: 0,
            totalPrice: item.sellingPrice,
            imeiCode: '',
            note: '',
            checked: item.checked,
          }
        })
        this.billModel.billItems.push(...giftItems)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      onAddGiftList(gifts) {
        if (!gifts || gifts.length === 0) {
          return
        }

        const giftItems = gifts.map((item) => {
          return {
            id: uuidv4(),
            itemType: ITEM_TYPE.GIFT,
            belongBillDetailId: item.belongBillDetailId,
            productId: item.productId,
            productName: item.productName,
            productCode: item.productCode,
            barCode: item.barCode,
            productType: item.productType,
            sellingPrice: item.sellingPrice,
            quantity: 1,
            discountType: AMOUNT_TYPE.MONEY,
            discountAmount: 0,
            totalPrice: item.sellingPrice,
            imeiCode: '',
            note: '',
            checked: item.checked,
          }
        })
        this.billModel.billItems.push(...giftItems)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      showModalFlexibleCombo() {
        setTimeout(() => {
          this.$refs['flexible-combo'].showModal()
        }, TIME_TRIGGER)
      },
      addComboChild(item) {
        this.billModel.billItems.push(item)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      addVoucher(billItem) {
        this.itemChoice.productName = billItem ? billItem.productName : ''
        this.itemChoice.productId = billItem.productId
        this.itemChoice.productAmount = billItem.sellingPrice
        this.itemChoice.billItemId = billItem.id
        this.itemChoice.discountProgramId = billItem.discountProgramId ?? null
        setTimeout(() => {
          this.$refs['apply-voucher-modal'].showModal()
        }, TIME_TRIGGER)
      },
      canAddVoucherToLine(line) {
        if (!line || line.flexibleComboId) {
          return false
        }
        if (this.enableMultiVoucherRetail) {
          // Read-only: KHÔNG gọi hydrateLineVouchersFromApi ở đây vì hàm này
          // được gọi trong template (v-if) khi render. Mutate line.vouchers lúc
          // render sẽ gây vòng lặp update vô hạn của Vue -> treo trang.
          // line.vouchers đã được hydrate 1 lần khi load dữ liệu (getBillByBillNumber).
          return this.lineVoucherEntries(line).length < MAX_VOUCHERS_PER_LINE
        }
        return !line.voucherCode
      },
      stackedProgramIdsForLine(billItemSelected) {
        const stackedIds = []
        const existingPeers = this.billModel.billItems.filter(
          (row) => row.voucherId === billItemSelected.voucherId && hasVoucherOnLine(row),
        )
        const peers = existingPeers.some((row) => row.id === billItemSelected.id)
          ? existingPeers
          : [...existingPeers, billItemSelected]
        peers.forEach((row) => {
          collectProgramIds(row).forEach((id) => stackedIds.push(id))
        })
        return [...new Set(stackedIds)]
      },
      async applyMultiVoucherLine(voucherItem) {
        const billItemSelected = this.resolveBillItemForVoucher(voucherItem?.billItemId)
        if (!billItemSelected) return

        hydrateLineVouchersFromApi(billItemSelected)
        const customerId = this.billModel.customerModel && this.billModel.customerModel.customerId
        const unit = Number(
          billItemSelected.sellingPriceMask || billItemSelected.sellingPrice || 0,
        )
        const qty = Number(billItemSelected.quantity || 1)
        const existingVouchers = this.lineVoucherEntries(billItemSelected).map((entry) => ({
          voucherCode: entry.voucherCode,
          voucherDetailId: entry.voucherDetailId,
          voucherAmount: entry.voucherAmount,
        }))
        const uniqueStacked = this.stackedProgramIdsForLine(billItemSelected)

        const validatePayload = {
          voucherCodes: [voucherItem.voucherCode],
          existingVouchers,
          productId: billItemSelected.productId,
          productPrice: unit,
          quantity: qty,
          storeId: this.billModel.storeId,
          customerId,
          billTotalAmount: calculateRetailBillTotalAmount(this.billModel.billItems),
          stackedDiscountProgramIds: uniqueStacked,
        }
        const res = await validateLineVouchers(validatePayload)
        if (res.status !== 1) {
          makeToastFaile(res.message)
          return
        }

        const mappedVouchers = (res.data.vouchers || []).map((entry, index) => ({
          voucherId: entry.voucherId,
          voucherDetailId: entry.voucherDetailId,
          voucherCode: entry.code,
          voucherAmount: Number(entry.discountAmount || 0),
          name: entry.name || '',
          sortOrder: index,
        }))
        this.$set(billItemSelected, 'vouchers', mappedVouchers)
        syncLegacyVoucherFieldsFromArray(billItemSelected)

        const programTotal = programOnlyLineDiscountRounded(billItemSelected)
        const voucherTotal = roundMoneyToThousand(Number(res.data.totalVoucherAmount || 0))
        const pid = Number(billItemSelected.discountProgramId)
        const hasProgramForStack =
          (Number.isFinite(pid) && pid > 0) ||
          parseExtraDiscountProgramIds(billItemSelected.extraDiscountProgramIds).length > 0 ||
          roundMoneyToThousand(programTotal) > 0

        if (hasProgramForStack) {
          applyStackedAmountsToLineDisplayFields(billItemSelected, programTotal, voucherTotal)
          billItemSelected.discount = billItemSelected.discountAmount
        } else {
          billItemSelected.discountType = AMOUNT_TYPE.MONEY
          billItemSelected.discountAmount = voucherTotal / qty
          billItemSelected.discount = billItemSelected.discountAmount
          clearSplitAmountFields(billItemSelected)
          billItemSelected.voucherAmount = voucherTotal
        }
      },
      async revalidateLineVouchers(billItem) {
        if (!billItem || !this.lineVoucherEntries(billItem).length) {
          return this.onRemoveVoucher(billItem)
        }
        const customerId = this.billModel.customerModel && this.billModel.customerModel.customerId
        const unit = Number(billItem.sellingPriceMask || billItem.sellingPrice || 0)
        const qty = Number(billItem.quantity || 1)
        const codes = this.lineVoucherEntries(billItem).map((entry) => entry.voucherCode)
        const uniqueStacked = this.stackedProgramIdsForLine(billItem)
        const res = await validateLineVouchers({
          voucherCodes: codes,
          existingVouchers: [],
          productId: billItem.productId,
          productPrice: unit,
          quantity: qty,
          storeId: this.billModel.storeId,
          customerId,
          billTotalAmount: calculateRetailBillTotalAmount(this.billModel.billItems),
          stackedDiscountProgramIds: uniqueStacked,
        })
        if (res.status !== 1) {
          makeToastFaile(res.message)
          return this.onRemoveVoucher(billItem)
        }
        const mappedVouchers = (res.data.vouchers || []).map((entry, index) => ({
          voucherId: entry.voucherId,
          voucherDetailId: entry.voucherDetailId,
          voucherCode: entry.code,
          voucherAmount: Number(entry.discountAmount || 0),
          name: entry.name || '',
          sortOrder: index,
        }))
        this.$set(billItem, 'vouchers', mappedVouchers)
        syncLegacyVoucherFieldsFromArray(billItem)
        const programTotal = programOnlyLineDiscountRounded(billItem)
        const voucherTotal = roundMoneyToThousand(Number(res.data.totalVoucherAmount || 0))
        const pid = Number(billItem.discountProgramId)
        const hasProgramForStack =
          (Number.isFinite(pid) && pid > 0) ||
          parseExtraDiscountProgramIds(billItem.extraDiscountProgramIds).length > 0 ||
          roundMoneyToThousand(programTotal) > 0
        if (hasProgramForStack) {
          applyStackedAmountsToLineDisplayFields(billItem, programTotal, voucherTotal)
        } else {
          billItem.discountType = AMOUNT_TYPE.MONEY
          billItem.discountAmount = voucherTotal / qty
          clearSplitAmountFields(billItem)
          billItem.voucherAmount = voucherTotal
        }
        billItem.discount = billItem.discountAmount
      },
      async onRemoveVoucherAt(billItem, voucherIndex) {
        if (!billItem) {
          return
        }
        const entries = this.lineVoucherEntries(billItem)
        const target = entries[voucherIndex]
        if (!target) {
          return this.onRemoveVoucher(billItem)
        }
        billItem.vouchers = (billItem.vouchers || []).filter(
          (entry) =>
            !(
              entry &&
              entry.voucherCode === target.voucherCode &&
              entry.voucherDetailId === target.voucherDetailId
            ),
        )
        if (!this.lineVoucherEntries(billItem).length) {
          return this.onRemoveVoucher(billItem)
        }
        await this.revalidateLineVouchers(billItem)
        this.$forceUpdate()
      },
      async onApplyVoucherItem(voucherItem) {
        if (this.enableMultiVoucherRetail) {
          await this.applyMultiVoucherLine({
            ...voucherItem,
            billItemId: voucherItem.billItemId || this.itemChoice.billItemId || this.itemChoice.id,
          })
        } else {
          await this.calVoucherCumluativeValue(voucherItem)
        }
        this.$forceUpdate()
      },
      async calVoucherCumluativeValue(voucherItem) {
        const billItemSelected = this.billModel.billItems.find(
          (billItem) => billItem.id === this.itemChoice.billItemId,
        )
        if (!billItemSelected) return

        const customerId = this.billModel.customerModel && this.billModel.customerModel.customerId
        const voucherRepo = RepositoryFactory.get('vouchers')
        const stackedIds = []
        const existingPeers = this.billModel.billItems.filter(
          (row) => row.voucherId === voucherItem.voucherId && hasVoucherOnLine(row),
        )
        const peers = existingPeers.some((row) => row.id === billItemSelected.id)
          ? existingPeers
          : [...existingPeers, billItemSelected]
        peers.forEach((row) => {
          collectProgramIds(row).forEach((id) => stackedIds.push(id))
        })

        const uniqueStacked = [...new Set(stackedIds)]
        if (uniqueStacked.length) {
          const unit = Number(
            billItemSelected.sellingPriceMask || billItemSelected.sellingPrice || 0,
          )
          const qty = Number(billItemSelected.quantity || 1)
          const res = await voucherRepo.validateCoupon({
            couponCode: voucherItem.voucherCode,
            storeId: this.billModel.storeId,
            customerId,
            products: [
              {
                productId: billItemSelected.productId,
                quantity: billItemSelected.quantity,
                sellingPrice: unit,
              },
            ],
            totalAmount: unit * qty,
            stackedDiscountProgramIds: uniqueStacked,
          })
          if (res.status !== 1) {
            makeToastFaile(res.message)
            return
          }
        }

        const programSnapById = {}
        peers.forEach((row) => {
          programSnapById[row.id] = this.programSnapshotForVoucher(row)
        })

        billItemSelected.voucherCode = voucherItem.voucherCode
        billItemSelected.voucherId = voucherItem.voucherId
        billItemSelected.voucherDetailId = voucherItem.voucherDetailId

        if (!voucherItem.cumluativeValues || !voucherItem.cumluativeValues.length) {
          const qty = Number(billItemSelected.quantity || 1)
          const programTotal = programOnlyLineDiscountRounded(billItemSelected)
          const pid = Number(billItemSelected.discountProgramId)
          const hasProgramForStack =
            (Number.isFinite(pid) && pid > 0) ||
            parseExtraDiscountProgramIds(billItemSelected.extraDiscountProgramIds).length > 0 ||
            roundMoneyToThousand(programTotal) > 0
          if (hasProgramForStack) {
            const voucherTotal = roundMoneyToThousand(Number(voucherItem.voucherValue || 0) * qty)
            applyStackedAmountsToLineDisplayFields(billItemSelected, programTotal, voucherTotal)
            billItemSelected.discount = billItemSelected.discountAmount
          } else {
            billItemSelected.discountType = AMOUNT_TYPE.MONEY
            billItemSelected.discountAmount = voucherItem.voucherValue
            billItemSelected.discount = voucherItem.voucherValue
            clearSplitAmountFields(billItemSelected)
          }
          billItemSelected.voucherCumluativeValues = []
          return
        }
        this.reCalVoucherBillItem(voucherItem, programSnapById)
      },
      calVoucherValue(voucherType, voucherValue, productAmount) {
        if (voucherType === AMOUNT_TYPE.MONEY) {
          return voucherValue
        }
        return (productAmount * voucherValue) / 100
      },
      reCalVoucherBillItem(voucherItem, programSnapById) {
        programSnapById = programSnapById || {}
        const billItemVouchers = this.billModel.billItems.filter(
          (billItem) => billItem.voucherId === voucherItem.voucherId,
        )
        const billItems = billItemVouchers.map((billItem) => {
          return {
            ...billItem,
            quantity: Number(billItem.quantity),
          }
        })
        const totalQuantity = sumBy(billItems, 'quantity')
        const cumluativeValueFound = voucherItem.cumluativeValues.find(
          (cumluativeValue) =>
            cumluativeValue.quantityFrom <= totalQuantity &&
            totalQuantity <= cumluativeValue.quantityTo,
        )
        const voucherCumluativeValue = cumluativeValueFound
          ? cumluativeValueFound.cumulativeValue
          : 0
        for (const billItemVoucher of billItemVouchers) {
          const vu = this.calVoucherValue(
            AMOUNT_TYPE.PERCENT,
            voucherCumluativeValue,
            billItemVoucher.sellingPriceMask || billItemVoucher.sellingPrice,
          )
          billItemVoucher.discountAmount = vu
          billItemVoucher.discount = vu
          billItemVoucher.discountType = AMOUNT_TYPE.MONEY
          billItemVoucher.voucherCumluativeValues = voucherItem.cumluativeValues

          const qtyV = Number(billItemVoucher.quantity || 1)
          let prog = programOnlyLineDiscountRounded(billItemVoucher)
          const stackVoucherWithProgram =
            (billItemVoucher.discountProgramId && Number(billItemVoucher.discountProgramId) > 0) ||
            parseExtraDiscountProgramIds(billItemVoucher.extraDiscountProgramIds).length > 0 ||
            roundMoneyToThousand(prog) > 0
          if (stackVoucherWithProgram) {
            const voucherTot = roundMoneyToThousand(vu * qtyV)
            applyStackedAmountsToLineDisplayFields(billItemVoucher, prog, voucherTot)
            billItemVoucher.discount = billItemVoucher.discountAmount
          } else {
            clearSplitAmountFields(billItemVoucher)
          }
        }
      },
      async onRemoveVoucher(billItem) {
        const productItemIndex = this.billModel.billItems.findIndex(
          (item) => item.id === billItem.id,
        )
        if (productItemIndex < 0) return
        const line = this.billModel.billItems[productItemIndex]
        line.prevVoucherId = billItem.voucherId
        line.voucherId = null
        line.voucherDetailId = null
        line.voucherCode = ''
        line.vouchers = []
        line.voucherCumluativeValues = []
        clearSplitAmountFields(line)
        line.discountAmount = 0
        line.discount = 0
        line.discountType = AMOUNT_TYPE.MONEY
        // Dòng có CTGG phụ: tính lại tổng CK program (parallel) sau khi bỏ voucher
        if (this.extraProgramCount(line) > 0) {
          this.recomputeStackedProgram(line)
          return
        }
        if (Number(line.discountProgramId) > 0 && this.billModel.storeId) {
          line.promotionProgramCode = ''
          line.promotionProgramName = ''
          line.originalPercentDiscountAmount = 0
          line.isOverMaxValue = 0
          const prevDp = line.discountProgramId
          line.discountProgramId = null
          await this.getProductDiscount(line)
          if (!line.discountProgramId) {
            line.discountProgramId = prevDp
            setProgramOnlySplitAmounts(line)
            line.discount = line.discountAmount
          }
        }
      },
      addProductWarranty(item) {
        this.itemChoice.id = item.id
        this.itemChoice.productId = item.productId
        this.itemChoice.productName = item.productName
        this.itemChoice.attachItems = item.attachItems || []
        setTimeout(() => {
          this.$refs['bill-warranty-modal'].showModal()
        }, TIME_TRIGGER)
      },
      addWarranty(attachs) {
        const warrantyItems = attachs.map((item) => {
          const finalPrice = Number(item.finalSellingPrice ?? item.sellingPrice ?? 0)
          return {
            id: item.id,
            itemType: item.itemType,
            belongBillDetailId: item.belongBillDetailId,
            productId: item.productId,
            productName: item.productName,
            barCode: item.barCode,
            productCode: item.productCode,
            productType: item.productType,
            sellingPrice: finalPrice,
            sellingPriceMask: finalPrice,
            quantity: 1,
            discountType: item.discountType,
            discountAmount: 0,
            totalPrice: finalPrice,
            imeiCode: '',
            promotionProgramCode: item.warrantyProgramCode,
            promotionProgramName: item.warrantyProgramName || '',
            note: '',
            checked: item.checked,
          }
        })
        this.billModel.billItems.push(...warrantyItems)
        this.billModel.billItems = sortListBillItem(this.billModel.billItems)
      },
      programSnapshotForVoucher(row) {
        if (parseExtraDiscountProgramIds(row.extraDiscountProgramIds).length > 0) {
          return roundMoneyToThousand(Number(row.discountProgramAmount) || 0)
        }
        return programOnlyLineDiscountRounded(row)
      },
      extraProgramCount(line) {
        if (Array.isArray(line.extraDiscountProgramItems)) {
          return line.extraDiscountProgramItems.length
        }
        return parseExtraDiscountProgramIds(line.extraDiscountProgramIds).length
      },
      extraProgramTooltip(line) {
        const items = line.extraDiscountProgramItems
        if (Array.isArray(items) && items.length) {
          return items
            .map((item) => {
              const { code, name } = labelsFromDiscountProgramApi(item)
              return name || code || `CK#${item.id}`
            })
            .join(', ')
        }
        const ids = parseExtraDiscountProgramIds(line.extraDiscountProgramIds)
        return ids.map((id) => `CK#${id}`).join(', ')
      },
      lineAttachProductIds(line) {
        return this.billModel.billItems
          .filter((item) => item.belongBillDetailId === line.id && item.productId)
          .map((item) => item.productId)
      },
      addExtraDiscountPrograms(productItem) {
        this.extraProgramContext = {
          billItemId: productItem.id,
          productName: productItem.productName || '',
          productId: productItem.productId,
          mainProgramId: productItem.discountProgramId ?? null,
          attachProductIds: this.lineAttachProductIds(productItem),
          selectedExtraIds: productItem.extraDiscountProgramIds || null,
        }
        setTimeout(() => {
          this.$refs['discount-program-stack-modal'].showModal()
        }, TIME_TRIGGER)
      },
      onApplyExtraDiscountPrograms({ billItemId, extraIds, programs, mainProgram }) {
        const line = this.billModel.billItems.find((item) => item.id === billItemId)
        if (!line) return
        const extras = (programs || []).map((program) => {
          const { code, name } = labelsFromDiscountProgramApi(program)
          return {
            id: Number(program.id),
            discountType: Number(program.discountType),
            discountAmount: Number(program.discountAmount),
            maxValue: Number(program.maxValue || 0),
            name,
            code,
          }
        })
        this.$set(line, 'extraDiscountProgramItems', extras)
        this.$set(
          line,
          'extraDiscountProgramIds',
          serializeExtraDiscountProgramIds(extraIds, line.discountProgramId),
        )
        const mainConfig = mainProgram
          ? {
              discountType: Number(mainProgram.discountType),
              discountAmount: Number(mainProgram.discountAmount),
              maxValue: Number(mainProgram.maxValue || 0),
            }
          : this.getMainProgramConfig(line)
        this.$set(line, 'mainProgramConfig', mainConfig)
        this.recomputeStackedProgram(line)
      },
      getMainProgramConfig(line) {
        if (line.mainProgramConfig) {
          return line.mainProgramConfig
        }
        if (Number(line.isOverMaxValue) === 1) {
          return {
            discountType: AMOUNT_TYPE.PERCENT,
            discountAmount: Number(line.originalPercentDiscountAmount || 0),
            maxValue: Number(line.maxValue || 0),
          }
        }
        return {
          discountType: Number(line.discountType || AMOUNT_TYPE.MONEY),
          discountAmount: Number(unMaskPrice(line.discountAmount || 0)),
          maxValue: Number(line.maxValue || 0),
        }
      },
      recomputeStackedProgram(line) {
        const unit = Number(line.sellingPriceMask || line.sellingPrice || 0)
        const qty = Number(line.quantity || 1) || 1
        const base = unit * qty
        const extras = Array.isArray(line.extraDiscountProgramItems)
          ? line.extraDiscountProgramItems
          : []

        // Không còn program phụ -> trả về luồng một program (legacy)
        if (!extras.length) {
          this.$set(line, 'extraDiscountProgramIds', null)
          this.$set(line, 'extraDiscountProgramItems', [])
          const mainConfig = line.mainProgramConfig
          if (mainConfig) {
            const overMax =
              mainConfig.discountType === AMOUNT_TYPE.PERCENT &&
              mainConfig.maxValue > 0 &&
              (unit * mainConfig.discountAmount) / 100 > mainConfig.maxValue
            line.discountType = overMax ? AMOUNT_TYPE.MONEY : mainConfig.discountType
            line.discountAmount = overMax ? mainConfig.maxValue : mainConfig.discountAmount
            this.$set(line, 'maxValue', mainConfig.maxValue)
            this.$set(line, 'isOverMaxValue', overMax ? 1 : 0)
          }
          if (!hasVoucherOnLine(line)) {
            setProgramOnlySplitAmounts(line)
            line.discount = line.discountAmount
          }
          return
        }

        const programs = []
        if (line.mainProgramConfig && Number(line.discountProgramId) > 0) {
          programs.push(line.mainProgramConfig)
        }
        extras.forEach((program) => programs.push(program))

        const programTotal = computeStackedProgramAmount(programs, base)
        const voucher = roundMoneyToThousand(line.voucherAmount || 0)
        line.discountProgramAmount = programTotal
        line.voucherAmount = voucher
        // Quy về tiền trên đơn vị để bảng tính đúng tổng dòng (mục 5/6)
        line.discountType = AMOUNT_TYPE.MONEY
        this.$set(line, 'maxValue', 0)
        this.$set(line, 'isOverMaxValue', 0)
        const total = programTotal + voucher
        line.discountAmount = qty > 0 ? total / qty : 0
        line.discount = line.discountAmount
      },
      getProductDiscount: async function (productItem) {
        const targetBillItem =
          this.billModel.billItems.find((item) => item.id === productItem.id) || productItem
        if (!targetBillItem.discountProgramId) {
          const params = {
            productId: targetBillItem.productId,
            storeId: this.billModel.storeId,
          }
          const query = {
            params: {
              productIds: [targetBillItem.productId],
            },
          }
          await ApiService.query(
            cmdUrl.DiscountProgramUrl.byProduct +
              `/${params.productId}` +
              `/${this.billModel.storeId}`,
            query,
          ).then((response) => {
            if (response.data.status === 1) {
              const discountProgram = response.data.data
              if (!discountProgram || discountProgram.length === 0) {
                return
              }
              const productDiscountProgram = discountProgram.find(
                (item) => String(item.productId) === String(targetBillItem.productId),
              )
              if (!productDiscountProgram) {
                return
              }
              const discountType = Number(productDiscountProgram.discountType || 1)
              const discountAmount = Number(productDiscountProgram.discountAmount || 0)
              const maxValue = Number(productDiscountProgram.maxValue || 0)
              const sellingPrice = Number(
                targetBillItem.sellingPriceMask || targetBillItem.sellingPrice || 0,
              )
              const discountAmountByPercent = (sellingPrice * discountAmount) / 100
              const isPercentOverMax =
                discountType === AMOUNT_TYPE.PERCENT &&
                maxValue > 0 &&
                discountAmountByPercent > maxValue

              // If percent discount exceeds max value, convert to fixed amount.
              targetBillItem.discountType = isPercentOverMax ? AMOUNT_TYPE.MONEY : discountType
              targetBillItem.discountAmount = isPercentOverMax ? maxValue : discountAmount
              this.$set(targetBillItem, 'maxValue', maxValue)
              this.$set(
                targetBillItem,
                'discountProgramId',
                Number(productDiscountProgram.id) || null,
              )
              const { code, name } = labelsFromDiscountProgramApi(productDiscountProgram)
              this.$set(targetBillItem, 'promotionProgramCode', code)
              this.$set(targetBillItem, 'promotionProgramName', name)
              this.$set(targetBillItem, 'isOverMaxValue', isPercentOverMax ? 1 : 0)
              this.$set(
                targetBillItem,
                'originalPercentDiscountAmount',
                discountType === AMOUNT_TYPE.PERCENT ? discountAmount : 0,
              )
              if (!hasVoucherOnLine(targetBillItem)) {
                setProgramOnlySplitAmounts(targetBillItem)
              }
            }
          })
        }
      },
    },
  }
</script>

<style lang="scss">
  .bill-product-table {
  .form-group {
    margin-bottom: 1rem;
  }
  table {
    td {
      vertical-align: middle !important;
    }
  }

  .bill-product-discount-cell {
    min-width: 0;
  }

  .bill-product-discount-stack-wrap {
    max-width: 100%;
    min-width: 0;
  }

  .bill-product-discount-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .bill-product-discount-input-group {
    width: 100%;
  }

  .bill-product-ctkm-name {
    display: block;
    max-width: 100%;
    min-width: 0;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
    box-sizing: border-box;
  }

  .bill-product-discount-stack-wrap .bill-product-ctkm-name {
    text-align: right;
  }

  .bill-product-extra-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    margin-left: auto;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
    color: #7e3af2;
    background-color: #f3eefe;
    border: 1px solid #e2d4fb;
  }

  .bill-product-extra-badge i {
    font-size: 0.7rem;
  }

  .bill-product-ctkm-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    margin-left: auto;
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.4;
    color: #0e9f6e;
    background-color: #def7ec;
    border: 1px solid #bcf0da;
  }

  .bill-product-ctkm-badge i {
    font-size: 0.7rem;
    flex-shrink: 0;
  }

  .bill-product-ctkm-badge__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  /* attach row: constrain badge width */
  .bill-product-discount-inner .bill-product-ctkm-name.d-inline-block {
    display: block !important;
    max-width: 100%;
    text-align: right;
    margin-left: auto;
  }
  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .bill-product-bulk-imei-btn {
    height: 2.5rem;
    min-height: 2.5rem;
    padding-left: 0.65rem;
    padding-right: 0.65rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    white-space: nowrap;
    line-height: 1.2;
    border-color: #ced4da;
    color: #3f4254;
    background-color: #fff;
  }

  .bill-product-bulk-imei-btn:hover:not(:disabled) {
    background-color: #f3f6f9;
    border-color: #b5b5c3;
    color: #181c32;
  }

  .bill-product-bulk-imei-btn:disabled {
    opacity: 0.65;
  }

  .bill-product-bulk-imei-btn__icon {
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .header-color {
    color: rgb(24, 28, 50);
  }
  .text-note {
    font-size: 12px;
    font-style: italic;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }
  .btn-hidden {
    padding: 0px;
    border: none;
    background-color: transparent !important;
  }
  .btn-imei .btn.btn-secondary {
    background-color: #cac9db;
    border-color: #ced4da;
  }
  .product-label {
    font-weight: 500;
  }
}
</style>

